/** Zapamiętany wybór zwinięcia menu; błąd lub brak wpisu = rozwinięte. */
const KEY = 'k1p4.menuZwiniete'

export function readMenuCollapsed(): boolean {
  try {
    return window.localStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

export function writeMenuCollapsed(collapsed: boolean): void {
  try {
    window.localStorage.setItem(KEY, collapsed ? '1' : '0')
  } catch {
    // Zapis jest wygodą przeglądarki; bez niego menu działa tak samo.
  }
}
